// extracted by mini-css-extract-plugin
export default {"button":"Hp-z","reviewSort":"Ip-z"};